import { Subject, SubscriptionLike } from 'rxjs';
import { Disposable } from '../data/disposable';

/**
 * Helper class for managing rxjs objects that exist for the lifetime of their consumer.
 */
export class RxjsLifetimeManager implements Disposable {

    /**
     * Container for active subscriptions that should be cleaned up in the OnDestroy call.
     */
    private subscriptions: SubscriptionLike[] = [];

    /**
     * Container for active subscriptions that should be cleaned up in the OnDestroy call.
     */
    private subjects: Subject<any>[] = [];

    /**
     * Adds rxjs subscriptions to this lifetime manager
     */
    public addSubscriptions(...subscriptions: SubscriptionLike[]) {
        subscriptions.forEach(subscription => {
            this.subscriptions.push(subscription);
        });
    }

    /**
     * Adds subjects to this lifetime manager
     */
    public addSubjects(...subjects: Subject<any>[]) {
        subjects.forEach(subject => {
            this.subjects.push(subject);
        });
    }

    /**
     * Disposes this instance freeing any resources consumed by it.
     * Unsubscribes all subscriptions and completes all subjects.
     */
    public dispose(): void {
        this.subjects.forEach((subject) => {
            if (subject && !subject.closed) {
                subject.complete();
            }
        });
        this.subscriptions.forEach((subscription) => {
            if (subscription && !subscription.closed) {
                subscription.unsubscribe();
            }
        });
    }
}
